import './Introduction.css';
import adware from '../image/adware.png'
import calendar from '../image/calendar.png'
import clock from '../image/clock.png'
import globe from '../image/globe.png'
import phone from '../image/phone.png'
import wall from '../image/wall.png'
import arrow from "../image/arrow.png";

function introduction() {
    return (
        <div className="antivirus section-bg-white">
            <div className='payment-title'>Nebular Antivirus</div>
            <div className='antivirus-content'>
                As mentioned in the features section, Nebular antivirus software is generally very reliable and, in the
                most recent test, above industry standard. According to usage tests, it’s the same story for the
                product’s usability… With no false detection's of legitimate software as malware, Nebular antivirus is
                miles ahead of the industry average (5, out of a possible 1,328,235). This makes for a great user
                experience and a refreshing lack of mistaken flagging up of harmless software which is all too common in
                antivirus products. The user interface of the product is very simple and easy to navigate, unlike other
                antivirus software with good feature sets.
            </div>
            <div className="advantage-points">
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={adware}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Removes Malware
                        </div>
                        <div className="advantage-point-content">
                            Detects and removes malicious software on your computer like viruses, adware or spyware.
                        </div>
                    </div>
                </div>
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={adware}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Removes Spyware
                        </div>
                        <div className="advantage-point-content">
                            Spyware secretly monitors what you do on your computer. Its aim is usually to capture
                            passwords, banking credentials and credit card details.
                        </div>
                    </div>
                </div>
            </div>
            <div className="advantage-points">
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={globe}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Web Protection
                        </div>
                        <div className="advantage-point-content">
                            Detect which websites are safe and can be trusted. Block malware websites and downloads.
                        </div>
                    </div>
                </div>
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={clock}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Real-Time Protection
                        </div>
                        <div className="advantage-point-content">
                            Real-Time protection runs in the background and monitors your system continuously, blocking
                            malware before it gets on your hard-drive.
                        </div>
                    </div>
                </div>
            </div>
            <div className="advantage-points">
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={adware}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Removes Adware
                        </div>
                        <div className="advantage-point-content">
                            Adware is malicious software that automatically displays or downloads advertising material
                            such as banners or pop-ups.
                        </div>
                    </div>
                </div>
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={calendar}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Scheduled Scans
                        </div>
                        <div className="advantage-point-content">
                            Set your own scheduled for system antivirus scans including what locations to scan.
                        </div>
                    </div>
                </div>
            </div>
            <div className="advantage-points">
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={wall}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Firewall
                        </div>
                        <div className="advantage-point-content">
                            Remote management of Windows firewall or built-in advanced firewall tools.
                        </div>
                    </div>
                </div>
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={clock}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Tune-Up
                        </div>
                        <div className="advantage-point-content">
                            Includes tools which will help with the speed and optimization of your computer.
                        </div>
                    </div>
                </div>
            </div>
            <div className="advantage-points">
                <div className='introduction-point'>
                    <img className='introduction-image' alt='error-img' src={phone}/>
                    <div className='introduction-point-box'>
                        <div className="introduction-point-title">
                            Phone Support
                        </div>
                        <div className="advantage-point-content">
                            24/7 phone support for billing and technical questions.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default introduction